import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Sort } from '@angular/material/sort';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { IFeature, IFeatureFilter } from './features.interface';
import { FeaturesService } from './features.service';
import { FeaturesModalComponent } from './features-modal/features-modal.component';
import { Broadcaster } from '../../../shared/components/broadcaster.component';
import { DialogService } from '../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../shared/services/auth.service';
import { IConfirmationDialogOptions } from '../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';

let self: any;

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.css']
})
export class FeaturesComponent implements OnInit {
  features: IFeature[] = [];
  loading: boolean = false;
  thereAreMore: boolean = false;
  filter: IFeatureFilter = {
    skip: 0,
    limit: 20
  };
  filtered = false;
  scrollSubscription!: Subscription;
  sortOptions: any = {
    "code": 'Valor asc',
    "-code": 'Valor desc',
    "name": 'Nombre asc',
    "-name": 'Nombre desc',
  };
  sortOptionsKeys = Object.keys(this.sortOptions);
  selection: any = { all: false };
  isDev: any;

  constructor(
    private _FeaturesService: FeaturesService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private _AuthService: AuthService
  ) {
    self = this;
    this.registerStringBroadcast();
  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    this.getFeatures(true);
  }

  getFeatures(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.features = [];
      this.clearSelection();
    }
    this._FeaturesService.getFeatures(this.filter).subscribe((features: any) => {
      this.features = _.concat(this.features, features);
      const filter: any = this.filter;
      this.thereAreMore = features.length >= filter.limit;
      this.loading = false;
    })
  }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      const filter: any = this.filter;
      filter.skip += filter.limit;
      this.getFeatures();
    }
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }

  sortFeatures(sort: any) {
    this.filter.sort = (typeof sort == 'string') ? sort : ((sort.direction == 'asc') ? '' : '-') + sort.active;
    this.getFeatures(true);
  }

  openFilter() {
    console.log('openFilter');
  }

  openNewFeatureModal() {
    this.openFeatureModal({});
  }

  openFeatureModal(feature: IFeature, readOnly: boolean = false) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '400px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(FeaturesModalComponent, config);
    self.dialogRef.componentInstance.feature = feature;
    self.dialogRef.componentInstance.readOnly = readOnly;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getFeatures(true);
    });
  }

  openDeleteFeatureConfirm(feature: IFeature, hardDelete: boolean = false) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Feature",
      message: "Esta seguro que desea eliminar '" + feature.name + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._FeaturesService.deleteFeature(feature, hardDelete).subscribe(() => {
            if (hardDelete) this.getFeatures(true);
            else feature.isDeleted = true;
          })
        }
      });
  }

  openRestoreSettingConfirm(feature: IFeature) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Restaurar Feature",
      message: "Esta seguro que desea restaurar '" + feature.name + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._FeaturesService.restoreFeature(feature).subscribe(() => {
            feature.isDeleted = false;
          })
        }
      });
  }

  clearSelection() {
    this.selection = { all: false }
  }

  checkSomeSelected() {
    this.selection.some = Object.keys(this.selection)
      .filter(el => el !== 'all' && el !== 'some')
      .filter(el => this.selection[el])
      .length > 0;
  }

  toggleSelection(_id?: string) {
    if (_id) {
      // Modificar la selección de un elemento individual
      this.selection[_id] = !this.selection[_id];

      // Verificar si todos los elementos están seleccionados
      const allSelected = this.features.every(feature => {
        const id = feature?._id || '';
        return this.selection[id];
      });

      // Actualizar "seleccionar todos" en base a los elementos seleccionados
      this.selection.all = allSelected;
    } else {
      // Seleccionar o deseleccionar todos
      const newValue = !this.selection.all;
      this.selection = { all: newValue };

      // Aplicar el nuevo estado a todos los elementos
      this.features.forEach(feature => {
        const id = feature?._id || '';
        this.selection[id] = newValue;
      });
    }

    // Actualizar si hay alguna selección
    this.checkSomeSelected();
  }
}